import React, { useState } from 'react';
import { Container, Row, Col, Carousel, Form, Button, Alert } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import './Home.css';
import R1 from '../images/R1.jpeg';
import R2 from '../images/R2.jpeg';
import R3 from '../images/R3.jpeg';
import R4 from '../images/R4.jpeg';
import R5 from '../images/R5.jpeg';
import R6 from '../images/R6.jpeg';
import R7 from '../images/R7.jpeg';
import R8 from '../images/R8.jpeg';
import R9 from '../images/R9.jpeg';
import R10 from '../images/R10.jpeg';
import R11 from '../images/R11.jpeg';
import R12 from '../images/R12.jpeg';
import R13 from '../images/R13.jpeg';
import R14 from '../images/R14.jpeg';

const Home = () => {
  const location = useLocation();
  
  // Initialize EmailJS with your public key
  emailjs.init("5Ud_1VfVwBANVpa1D");
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: location.state?.tripName ? `I would like to book the ${location.state.tripName}` : ''
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [isLoading, setIsLoading] = useState(false);

  const bannerImages = [
    {
      src: R1,
      //alt: 'White water rafting adventure',
      //title: 'Experience the Thrill',
      //caption: 'Conquer the rapids'
    },
    {
      src: R2,
    },
    {
      src: R3,
    },
    {
      src: R4,
    },
    {
      src: R5,
    },
    {
      src: R6,
    },
    {
      src: R7,
    },
    {
      src: R8,
    },
    {
      src: R9,
    },
    {
      src: R10,
    },
    {
      src: R11,
    },
    {
      src: R12,
    },
    {
      src: R13,
    },
    {
      src: R14,
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      setAlertType('danger');
      setAlertMessage('Please fill in all required fields.');
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 5000);
      return;
    }
    
    setIsLoading(true);
    setShowAlert(false);
    
    try {
      // Template parameters
      const templateParams = {
        name: formData.name,
        email: formData.email,
        message: formData.message
      };
      
      // Send email using EmailJS
      const response = await emailjs.send(
        'service_haruvdm',
        'template_6qrmjbg', 
        templateParams
      );
      
      console.log('Email sent successfully:', response.text);
      
      setAlertType('success');
      setAlertMessage('Message sent successfully! We\'ll get back to you soon.');
      setFormData({
        name: '',
        email: '',
        message: ''
      });
      setShowAlert(true);
      
    } catch (error) {
      console.error('Failed to send email:', error);
      setAlertType('danger');
      setAlertMessage(`Failed to send message: ${error.text || 'Unknown error. Please try again.'}`);
      setShowAlert(true);
    } finally {
      setIsLoading(false);
      setTimeout(() => setShowAlert(false), 5000);
    }
  };

  return (
    <Container fluid className="p-0">
      {/* Loading Bar */}
      {isLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          backgroundColor: '#FFD700',
          zIndex: 9999,
          animation: 'loading 1.5s infinite'
        }} />
      )}
      
      {/* Alert */}
      {showAlert && (
        <Alert 
          variant={alertType} 
          className="m-0" 
          style={{
            position: 'fixed',
            top: '8px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            minWidth: '300px',
            textAlign: 'center'
          }}
          onClose={() => setShowAlert(false)} 
          dismissible
        >
          {alertMessage}
        </Alert>
      )}
      
      {/* Hero Banner */}
      <Carousel fade interval={3000} className="mb-4 mb-md-5" style={{paddingTop: '20px'}}>
        {bannerImages.map((image, index) => (
          <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              src={image.src}
              alt={image.alt || `Rafting image ${index + 1}`}
              style={{ height: '600px', minHeight: '250px', maxHeight: '600px', objectFit: 'contain' }}
            />
            {image.title && (
              <Carousel.Caption className="custom-carousel-caption">
                <h2>{image.title}</h2>
                <p>{image.caption}</p>
              </Carousel.Caption>
            )}
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Introduction Section */}
      <Container className="py-4 py-md-5 px-3 px-md-4">
        <Row className="justify-content-center text-center mb-4 mb-md-5">
          <Col xs={12} md={10} lg={8}>
            <h1 className="display-5 display-md-4 fw-bold mb-3 mb-md-4">Welcome to KM Rafting Adventures</h1>
            <h2 className="h4 h-md-3">Experience the Thrill of the Ash River!</h2>
            <p className="lead">
              What to Expect:<br />
                - Exciting white-river rafting experience <br />
                - Safe and guided adventure <br />
                - Perfect for families, friends and team-building <br />
            </p>
          </Col>
        </Row>

        {/* Socials and Location Section */}
        <Row className="justify-content-center g-4 mb-4">
          
          <Col xs={12} md={10} lg={4}>
            <div className="bg-primary text-white p-3 p-md-4 rounded shadow h-100">
              <h2 className="mb-3 mb-md-4 h3">Socials</h2>
              <div className="d-flex flex-column gap-3">
                <a 
                  href="https://www.facebook.com/people/KM-Adventure/61584820411691/#" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="social-link facebook-link"
                >
                  <i className="fab fa-facebook-f me-2"></i>
                  Facebook
                </a>
                <a 
                  href="https://www.instagram.com/p/DAPMAheyvvf/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="social-link instagram-link"
                >
                  <i className="fab fa-instagram me-2"></i>
                  Instagram
                </a>
              </div>
            </div>
          </Col>
          
          <Col xs={12} md={10} lg={4}>
            <div className="bg-primary text-white p-3 p-md-4 rounded shadow h-100">
              <h2 className="mb-3 mb-md-4 h3">Location</h2>
              <div className="ratio ratio-16x9">
                <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.4315902564585!2d28.420691500000014!3d-28.526744499999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e8d5977129ce797%3A0xba217b9e3f1675f5!2sKM%20Rafting%20Adventures!5e0!3m2!1sen!2sza!4v1768547225740!5m2!1sen!2sza" 
                style={{border: 0}} 
                title="KM Rafting Adventures Location Map"
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade">
                </iframe>
              </div>
            </div>
          </Col>
        </Row>

        {/* Contact Form Section */}
        <Row className="justify-content-center" id="contact-form">
          <Col xs={12} md={10} lg={8}>
            <div className="bg-primary text-white p-3 p-md-4 rounded shadow">
              <h2 className="mb-3 mb-md-4 h3">Contact Us</h2>
              <div className="contact-info mb-4">
                <p className="mb-2"><strong>Name:</strong> KM Adventures</p>
                <p className="mb-2"><strong>Email:</strong> info@kmadventures.co.za</p>
                <p className="mb-3"><strong>Phone:</strong> 066 462 8164</p>
              </div>
              
              <div className="alert alert-danger mb-3" role="alert">
                <h5 className="alert-heading h6">NB</h5>
                <p className="mb-0">
                  When contacting us, please let us know your group size and please provide your phone number. Along with any questions you may have regarding our activities
                </p>
              </div>
              
              <Form id="contact-form" onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group controlId="name">
                      <Form.Label className="text-white">Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Your name"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="email">
                      <Form.Label className="text-white">Email *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Your email"
                        required
                      />
                    </Form.Group>
                  </Col>
                  
                  <Col xs={12}>
                    <Form.Group controlId="message">
                      <Form.Label className="text-white">Message *</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows={4}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Button 
                      variant="danger"
                      type="submit" 
                      className="raft-submit-btn"
                      style={{
                        width: '100%',
                        textAlign: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      Send Message
                    </Button>
                  </Col>
                </Row>
              </Form>
              
              
            </div>
          </Col>
        </Row>
      </Container>

      
      
      
    </Container>
  );
};

export default Home;